let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jtWxq")).then(() => parcelRequire('1Z04w'));